<template>
  <div class="ui grid">
    <div class="four wide column" v-if="!alternative_view">
      <professor-picker @select_professor="select_professor" />
    </div>
    <div :class="(alternative_view ? 'sixteen' : 'twelve') + ' wide column'">
      <professor-detail
        ref="professor_detail"
        :careers="careers"
        :branches="branches"
        :studying_times="studying_times"
        :schedules="schedules"
        :days="days"
        :season="season"
        @alternate_view="alternate_view"
      />
    </div>
  </div>
</template>

<script>
import ProfessorPicker from "./ProfessorPicker";
import ProfessorDetail from "./ProfessorDetail";

import filters from "@/filters";
import { local_api, error_toast, enterprise_setup } from "@/utils";

// @ is an alias to /src
export default {
  name: "CourseAssignationDistributionProfessorBasedIndex",
  props: { season: Object },
  components: {
    ProfessorPicker,
    ProfessorDetail,
  },
  filters: filters,
  data() {
    return {
      careers: [],
      branches: [],
      studying_times: [],
      schedules: [],
      days: [],
      alternative_view: false,
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    alternate_view() {
      let vm = this;
      vm.alternative_view = !vm.alternative_view;
    },
    // init() {
    //   let vm = this;
    //   let distribution_uuid = this.$route.query.i;
    //   if (distribution_uuid) {
    //     local_api(vm, "post", "/course/assignation/do-get", {
    //       u: distribution_uuid,
    //     })
    //       .then((assignation) => {
    //         vm.assignation = assignation;
    //         vm.$emit("set_assignation", assignation);

    //         // if (assignation && assignation.setup && assignation.setup.courses) {
    //         if (assignation && assignation.distinctCourses) {
    //           let ordered = assignation.distinctCourses.sort((a, b) => {
    //             return a.course.name.localeCompare(b.course.name);
    //             // if (a.name > b.name) return 1;
    //             // else if (a.name < b.name) return -1;
    //             // else return 0;
    //           });
    //           assignation.setup.courses = ordered;
    //         }

    //         setTimeout(() => {
    //           window
    //             .jQuery(vm.$refs.tabs)
    //             .find(".item")
    //             .tab();
    //         }, 1000);
    //       })
    //       .catch((err) => {
    //         error_toast(err);
    //       });
    //   } else {
    //     error_toast(this.$t("no course distribution found"));
    //   }
    // },
    select_professor(professor) {
      this.$refs.professor_detail.setProfessor(professor);
      // console.log("preparing to change to professor", professor);
    },
    setUsers(users) {
      this.$refs.professor_detail.setUsers(users);
    },
  },
  created() {},
  mounted() {
    let vm = this;
    // vm.init();
    /**
     * Get careers and branches
     */
    local_api(vm, "post", "/student_configuration/do-get-configuration", {})
      .then((studentConfiguration) => {
        vm.careers = studentConfiguration.std_careers;
        vm.branches = studentConfiguration.std_branches;
        vm.studying_times = studentConfiguration.std_studying_times;
      })
      .catch((err) => {
        error_toast(err);
      });

    // /**
    //  * Get course assignation module configuration
    //  */
    local_api(vm, "post", "/course/assignation/do-get-configuration", {})
      .then((r) => {
        if (r && r.conf && r.conf.setup && r.conf.setup.schedules) {
          vm.schedules = r.conf.setup.schedules;
        }
      })
      .catch((err) => {
        error_toast(err);
      });

    /**
     * Get course record module configuration
     */
    local_api(vm, "post", "/course/record/do-get-configuration", {})
      .then((r) => {
        if (r && r.days) {
          vm.days = r.days;
        }
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  watch: {},
};
</script>
